import { OVERVIEW_SHADOW_SERIES_NAME } from "@/widgets/print-overview/shared";

/**
 * Business callback: axis-trigger tooltip for BOTH print-overview charts.
 * The charts prepend an invisible "shadow" line series (it feeds the
 * scrollbar's data shadow — see `buildShadowSeries`); this formatter drops
 * that series so the tooltip shows exactly the four real comparison
 * entries, skipping the last-year rows where the response has no data
 * (`null` — e.g. the earliest year of the range).
 */
export function printOverviewTooltip(params: unknown): string {
  const list = (Array.isArray(params) ? params : [params]) as {
    name?: string;
    seriesName?: string;
    value?: unknown;
  }[];
  if (list.length === 0) return "";

  const localeTag = document.documentElement.lang || "en-US";
  const fmt = new Intl.NumberFormat(localeTag, { maximumFractionDigits: 3 });

  const header = `<div><strong>${list[0].name ?? ""}</strong></div>`;
  const lines = list
    .filter((item) => item.seriesName !== OVERVIEW_SHADOW_SERIES_NAME)
    .map((item) => {
      const value = typeof item.value === "number" ? item.value : Number(item.value);
      // Missing last-year data (null) renders no row at all.
      if (!Number.isFinite(value)) return "";
      return `<div>${item.seriesName ?? ""}: <strong>${fmt.format(value)}</strong></div>`;
    })
    .filter((line) => line !== "");

  return [header, ...lines].join("");
}
